(function(){
  var root = document.querySelector('[data-ba]');
  if(!root) return;

  var compare      = root.querySelector('[data-compare]');
  var wrap         = root.querySelector('.ba-compare__wrap');
  var handle       = root.querySelector('[data-handle]');
  var beforeImg    = root.querySelector('[data-before-img]');
  var afterImg     = root.querySelector('[data-after-img]');
  var swatchesWrap = root.querySelector('[data-swatches]');

  if(!compare || !wrap || !handle || !beforeImg || !afterImg) return;

  (function(){
    var t = beforeImg.src;
    beforeImg.src = afterImg.src;
    afterImg.src = t;
  })();

  var dragging = false;
  var activePointerId = null;

  function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

  function setByClientX(clientX){
    var rect = wrap.getBoundingClientRect();
    var p = (clientX - rect.left) / rect.width;
    p = clamp(p, 0.08, 0.92);
    root.style.setProperty('--ba-pos', (p * 100).toFixed(3) + '%');
  }

  function startDrag(e){
    dragging = true;
    activePointerId = e.pointerId;
    handle.classList.add('is-drag');
    try { wrap.setPointerCapture(activePointerId); } catch(err){}
    setByClientX(e.clientX);
    e.preventDefault();
  }

  function moveDrag(e){
    if(!dragging) return;
    if(activePointerId !== null && e.pointerId !== activePointerId) return;
    setByClientX(e.clientX);
    e.preventDefault();
  }

  function endDrag(e){
    if(!dragging) return;
    if(activePointerId !== null && e.pointerId !== activePointerId) return;
    dragging = false;
    activePointerId = null;
    handle.classList.remove('is-drag');
    try { wrap.releasePointerCapture(e.pointerId); } catch(err){}
    e.preventDefault();
  }

  wrap.addEventListener('pointerdown', startDrag);
  wrap.addEventListener('pointermove', moveDrag);
  wrap.addEventListener('pointerup', endDrag);
  wrap.addEventListener('pointercancel', endDrag);

  wrap.addEventListener('click', function(e){
    if(dragging) return;
    setByClientX(e.clientX);
  });

  function setActiveSwatch(setId){
    if(!swatchesWrap) return;
    swatchesWrap.querySelectorAll('.ba-swatch').forEach(function(b){
      if(b.getAttribute('data-set-id') === String(setId)) b.setAttribute('aria-current','true');
      else b.removeAttribute('aria-current');
    });
  }

  function swapImages(beforeUrl, afterUrl){
    var dur = 180;
    beforeImg.classList.add('is-fading');
    afterImg.classList.add('is-fading');
    window.setTimeout(function(){
      if(beforeUrl) beforeImg.src = beforeUrl;
      if(afterUrl)  afterImg.src  = afterUrl;
      window.setTimeout(function(){
        beforeImg.classList.remove('is-fading');
        afterImg.classList.remove('is-fading');
        root.style.setProperty('--ba-pos', '50%');
      }, 30);
    }, dur);
  }

  root.querySelectorAll('.ba-swatch').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var setId = btn.getAttribute('data-set-id');
      var b = btn.getAttribute('data-before') || '';
      var a = btn.getAttribute('data-after')  || '';
      if(!b || !a) return;
      setActiveSwatch(setId);
      swapImages(a, b);
    });
  });

  var swWrapper  = root.querySelector('[data-swatches-wrapper]');
  var swViewport = root.querySelector('[data-swatches-viewport]');
  var btnUp      = swWrapper && swWrapper.querySelector('.ba-snav--up');
  var btnDown    = swWrapper && swWrapper.querySelector('.ba-snav--down');
  var SWATCH_SIZE = 44;
  var SWATCH_GAP  = 14;
  var STEP = SWATCH_SIZE + SWATCH_GAP;

  function isDesktop(){ return window.innerWidth > 900; }

  function updateSwNav(){
    if(!swViewport || !btnUp || !btnDown || !swWrapper) return;
    if(!isDesktop()){
      swWrapper.classList.remove('has-overflow');
      return;
    }
    var hasOverflow = swViewport.scrollHeight > swViewport.clientHeight + 2;
    swWrapper.classList.toggle('has-overflow', hasOverflow);
    btnUp.classList.toggle('is-disabled',   swViewport.scrollTop <= 2);
    btnDown.classList.toggle('is-disabled', swViewport.scrollTop + swViewport.clientHeight >= swViewport.scrollHeight - 2);
  }

  if(swViewport && btnUp && btnDown){
    btnUp.addEventListener('click', function(){
      swViewport.scrollBy({ top: -STEP, behavior: 'smooth' });
      setTimeout(updateSwNav, 320);
    });
    btnDown.addEventListener('click', function(){
      swViewport.scrollBy({ top: STEP, behavior: 'smooth' });
      setTimeout(updateSwNav, 320);
    });

    swViewport.addEventListener('scroll', updateSwNav, { passive: true });

    var swDragging = false, swStartY = 0, swScrollStart = 0;

    swViewport.addEventListener('mousedown', function(e){
      if(!isDesktop()) return;
      swDragging = true;
      swStartY = e.pageY - swViewport.getBoundingClientRect().top;
      swScrollStart = swViewport.scrollTop;
      swViewport.style.cursor = 'grabbing';
    });
    document.addEventListener('mouseup', function(){
      swDragging = false;
      if(swViewport) swViewport.style.cursor = '';
    });
    document.addEventListener('mousemove', function(e){
      if(!swDragging || !isDesktop()) return;
      e.preventDefault();
      var y = e.pageY - swViewport.getBoundingClientRect().top;
      swViewport.scrollTop = swScrollStart - (y - swStartY) * 1.5;
    });

    window.addEventListener('resize', updateSwNav);
    updateSwNav();
    setTimeout(updateSwNav, 200);
  }
})();